import {
    Mark,
    mergeAttributes,
} from '@tiptap/core';
import {type HTMLAttributes} from 'react';

export const MentionMark = Mark.create({
    name: 'mention',

    addAttributes() {
        return {
            id: {
                default: null,
                parseHTML: (element: HTMLElement) => element.getAttribute('data-mention'),
                renderHTML: (attributes: HTMLAttributes<HTMLElement>) => {
                    if (!attributes.id) {
                        return {};
                    }

                    return {
                        'data-mention': attributes.id,
                    };
                },
            },
        };
    },

    parseHTML() {
        return [
            {
                priority: 101,
                tag: '[data-mention]',
            },
        ];
    },

    renderHTML({HTMLAttributes}) {
        return ['span', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes)];
    },
});
